import React from 'react';
import PropTypes from 'prop-types';
import formatObjectField from '../../utils/formatObjectField';
import Panel from '../Panel';

import './module.css';

const OptionsPanel = ({
  options
}) => {
  let boolOptions = [];
  let stringOptions = [];
  let numberOptions = [];

  for (let key in options) {
    if (typeof options[key] === 'boolean') {
      boolOptions.push(
        <div key={key} styleName="property-container">
          <i
            className={options[key] ? 'icon-budicon-500' : 'icon-budicon-501'}
            styleName={options[key] ? 'status-icon success' : 'status-icon fail'} />
          <div
            styleName="property-key">
            { formatObjectField(key).toUpperCase() }
          </div>
        </div>
      );
    } else if (typeof options[key] === 'string') {
      stringOptions.push(
        <div key={key} styleName="property-key">
          { formatObjectField(key).toUpperCase() }
          <div styleName="property-value">
            { options[key].length > 0 ? options[key] : '(empty)' }
          </div>
        </div>
      );
    } else if (typeof options[key] === 'number') {
      numberOptions.push(
        <div key={key} styleName="property-key">
          { formatObjectField(key).toUpperCase() }
          <div styleName="property-value">
            { options[key] }
          </div>
        </div>
      );
    }
  }

  return (
    <Panel>
      { boolOptions }
      { stringOptions }
      { numberOptions }
    </Panel>
  );
};

OptionsPanel.propTypes = {
  options: PropTypes.object.isRequired
};

export default OptionsPanel;
